import { createStore, compose, applyMiddleware } from 'redux';
import * as Sentry from '@sentry/react';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './reducers';
import rootSaga from './sagas';
import middleware from './middleware';
import { hydrateStore } from './middleware/local_storage';
import { MODELS_LIST } from './ActionTypes';

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && process.env.NODE_ENV === 'development'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        actionSanitizer: (action) =>
          [
            MODELS_LIST.FETCH_MODELS_SUCCEEDED,
            MODELS_LIST.SELECT_GRID_ROW,
            MODELS_LIST.SET_SELECTED_GRID_ROWS,
          ].includes(action.type) && action.payload
            ? { ...action, payload: '<<LONG_BLOB>>' }
            : action,
      })
    : compose;

const initialState = {};

const sagaMiddleware = createSagaMiddleware();

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

const store = () =>
  createStore(
    rootReducer,
    hydrateStore(initialState),
    composeEnhancers(applyMiddleware(sagaMiddleware, ...middleware), sentryReduxEnhancer)
  );

const Store = store();

sagaMiddleware.run(rootSaga);

export default Store;
